module.exports = __webpack_public_path__ + "static/media/chevron-right.811b0e52.svg";